export const TRUST_URL = "https://trust.igcfirm.com";
